<template>
    <div class="relative flex min-h-screen items-center justify-center overflow-hidden bg-default p-4">
        <div class="pointer-events-none absolute inset-0 opacity-60"
             :style="{ background: 'radial-gradient(60% 50% at 50% 0%, var(--ui-primary) 0%, transparent 70%)' }" />
        <div class="relative w-full max-w-md">
            <router-view />
        </div>
    </div>
</template>
